module.exports = __webpack_public_path__ + "img/success.1cec5cf7.svg";